import { Box, Button, Stack, Typography, useTheme } from '@mui/material'
import { FC } from 'react'
import BellIcon from '../../assets/icons/Bell.svg'
import { ModalDialogWrapper } from '../../components/ModalDialogWrapper'

type Props = {
    open: boolean
    onClose: VoidFunction
    onAccept: VoidFunction
    onDecline: VoidFunction
}

export const WebPushPermissionRequestDialog: FC<Props> = ({
    open,
    onClose,
    onAccept,
    onDecline,
}) => {
    const { breakpoints } = useTheme()

    return (
        <ModalDialogWrapper
            open={open}
            handleClose={onClose}
            title={
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '100px',
                        padding: '10px',
                        backgroundColor: '#006CFD',
                        color: '#FFFFFF',
                    }}>
                    <BellIcon />
                </Box>
            }
            sx={{
                '.MuiPaper-root': {
                    width: '390px',
                    maxWidth: '390px',

                    [breakpoints.down('sm')]: {
                        width: '100%',
                        maxWidth: '100%',
                    },
                },
            }}
            footerActions={
                <>
                    <Stack
                        sx={{
                            width: '100%',
                            flexDirection: 'row',
                            gap: 2,

                            [breakpoints.down('sm')]: {
                                gap: 1,
                            },
                        }}>
                        <Button
                            variant="contained"
                            onClick={onAccept}
                            sx={{
                                width: '50%',
                            }}>
                            Разрешить
                        </Button>
                        <Button
                            variant="text"
                            onClick={onDecline}
                            sx={{
                                width: '50%',
                            }}>
                            Не разрешать
                        </Button>
                    </Stack>
                </>
            }>
            <Stack direction="column" gap={1}>
                <Stack direction="column">
                    <Typography variant="h4">Разрешение на отправку</Typography>
                    <Typography variant="h4">Push-уведомлений</Typography>
                </Stack>
                <Typography variant="caption2" color="#5A5F72">
                    Получать уведомления о выполненных задачах, изменениях в аккаунте и новостях
                    сервиса
                </Typography>
            </Stack>
        </ModalDialogWrapper>
    )
}
